import { ResearchReportBaseLoader } from './_research_report_base_loader';

export class ResearchSavedReportLoader extends ResearchReportBaseLoader {
}
